import React from 'react'
function Footer() { 
    return (
        <>
        <h2>Footer</h2> <br /> <br />
        </>
    )
}
export default Footer;
